import { render, staticRenderFns } from "./Tijdsbesteding.vue?vue&type=template&id=28b55e3c&scoped=true&"
import script from "./Tijdsbesteding.vue?vue&type=script&lang=js&"
export * from "./Tijdsbesteding.vue?vue&type=script&lang=js&"
import style0 from "./Tijdsbesteding.vue?vue&type=style&index=0&id=28b55e3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b55e3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VFlex,VLayout,VSlider})
